class ScrollingLine extends HTMLElement {
  constructor() {
    super();

    this.firstInit = false;
    this.scrollerInner = this.querySelector('[data-scroller="inner"]');
    this.scrollerChildren = [...this.scrollerInner.children];

    this.debouncedOnResize = debounce(() => {
      this.setAnimation();
    }, 100);
  }

  connectedCallback() {
    if (!this.scrollerChildren) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    window.addEventListener('resize', this.debouncedOnResize.bind(this));
    this.setAnimation();
  }

  addAnimation() {
    this.setAttribute('data-scroller', 'animated');
    this.firstInit = true;
  }

  removeAnimation() {
    this.removeAttribute('data-scroller');
  }

  setAnimation() {
    if (!window.matchMedia('(max-width: 750px)').matches) {
      this.removeAnimation();
      this.firstInit = false;
      return
    }

    if (this.firstInit) return;
    this.addAnimation();
  }
}

customElements.define('scrolling-line', ScrollingLine);
